module.exports = __webpack_public_path__ + "public/img/bar-1.bc13c2d7.png";